import {
  FETCH_CMS_MTO_REQUEST,
  FETCH_CMS_MTO_UPDATE,
  FETCH_CMS_DELIVERY_REQUEST,
  FETCH_CMS_DELIVERY_UPDATE
} from '../../actionTypes/cmsActionTypes'

const initialState = {
  mto: {
    handcrafted: null,
    measure: null,
    delivery: null
  },
  twoManDelivery: null
}

const buildMTOUpdate = (oldState, payload) => {
  const newState = {
    ...oldState,
    mto: {
      ...oldState.mto,
      ...payload
    }
  }

  return newState
}

const cmsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_CMS_MTO_REQUEST:
      return state
    case FETCH_CMS_MTO_UPDATE:
      return buildMTOUpdate(state, payload)
    case FETCH_CMS_DELIVERY_REQUEST:
      return state
    case FETCH_CMS_DELIVERY_UPDATE:
      return {
        ...state,
        twoManDelivery: payload
      }

    default:
      return state
  }
}

export { initialState, cmsReducer }
